import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import {keyframes} from '@emotion/core';

const scale = keyframes`
  100% {
    transform: scaleY(0.5);
  }
`;

const animateOpacity = keyframes`
  100% {
    opacity: 0.4;
  }
`;

const Icon = styled.svg`
  .active &,
  .idle & {
    #waveOne {
      animation: ${animateOpacity} 5s cubic-bezier(0.4, 0, 1, 1) infinite
          alternate,
        ${scale} 5s cubic-bezier(0.4, 0, 1, 1) infinite alternate;
    }
    #waveTwo {
      animation: ${animateOpacity} 4s 1s cubic-bezier(0.4, 0, 1, 1) infinite
          alternate,
        ${scale} 5s 1s cubic-bezier(0.4, 0, 1, 1) infinite alternate;
    }
  }
  .cls-1 {
    fill: #fff;
    opacity: 0.2;
    transform-origin: bottom;
  }

  .cls-2 {
    fill: none;
    stroke: #fff;
    stroke-miterlimit: 10;
    stroke-width: 2px;
  }
`;

export const ReservoirIcon = () => {
  return (
    <Icon viewBox='0 0 71 72'>
      <g id='Layer_2' data-name='Layer 2'>
        <g id='reservoirs'>
          <g id='reservoirs-icon'>
            <path
              id='waveOne'
              className='cls-1'
              d='M1,46V71H71V46s-11,3-13,3c-4.37,0-14-3-20-3-7,0-6,3-17,3-4.37,0-9.63-4-14-4A35.36,35.36,0,0,0,1,46Z'
            />
            <path
              id='waveTwo'
              className='cls-1'
              d='M1,46V71H71V46s-2,3-4,3c-4.37,0-14-3-20-3-7,0-6,3-17,3-4.37,0-9.63-4-14-4C14,45,1,46,1,46Z'
            />
            <polygon
              className='cls-2'
              points='1 1 1 71 71 71 71 1 61 1 50 39 22 39 11 1 1 1'
            />
          </g>
        </g>
      </g>
    </Icon>
  );
};

ReservoirIcon.propTypes = {
  active: PropTypes.bool,
};
